module.exports = __webpack_public_path__ + "img/thumb_25.36fdc247.jpg";